import { WorkOrderStatus, WorkOrderStatusForm } from "../store/data/entities/work-order";

export const reopenReasonRequiredMessage = "Please provide a reason.";

export function buildReopenWorkOrderStatusForm(
  workOrderId: string,
  reason: string
): WorkOrderStatusForm {
  return {
    workOrderId,
    status: WorkOrderStatus.Approved,
    reason: reason.trim()
  };
}

export function isReopenReasonValid(reason?: string | null): boolean {
  return !!reason?.trim();
}
